document.querySelectorAll('.js-product-filter').forEach((el) => {
    el.addEventListener('change', (e) => {
        let formData = new FormData();
        formData.append( 'action', 'products' );
        formData.append( 'cat', el.closest('.products__filter').getAttribute('data-category') );

        el.closest('.products').querySelector('.products__wrapper').classList.add('is-loading');

        let terms = [];
        document.querySelectorAll('.products__filter .filter__block').forEach((el) => {
            const attribute = el.getAttribute('data-attribute');

            if (el.querySelectorAll('.js-product-filter:checked').length !== 0) {
                el.querySelectorAll('.js-product-filter:checked').forEach((el) => {
                    terms.push(parseInt(el.getAttribute('data-id')));
                });

                formData.append( attribute, JSON.stringify(terms) );
            }
        });

        console.log(terms);

        fetch(adminUrl, {
            method: 'post',
            body: formData,
        })
            .then((response) => {
                return response.text();
            })
            .then((response) => {
                el.closest('.products').querySelector('.products__wrapper').classList.remove('is-loading');
                document.querySelector('.js-products').innerHTML = `<div class="wrapper__loader"><div class="loader__spinner"></div></div> ${response}`;

                if (terms.length > 0) {
                    document.querySelector('.js-products').classList.add('has-filter-active');
                } else {
                    document.querySelector('.js-products').classList.remove('has-filter-active');
                }
            })
            .catch((response) =>{
                console.log(response);
                el.closest('.products').querySelector('.products__wrapper').classList.remove('is-loading');
            });
    });
});

document.addEventListener('click', (e) => {
    if (!e.target.closest('.js-filter-toggle')) return;

    document.querySelector('.products__filter').classList.toggle('is-visible');
});

document.addEventListener('click', function(e) {
    const filters = document.querySelector('.products__filter.is-visible');

    if (filters) {
        if (!e.target.closest('.products__filter') && !e.target.closest('.js-filter-toggle')) {
            filters.classList.remove('is-visible');
        }
    }
});

